var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugcareLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2522 68.4188L6.9024 40.1484C-0.454848 31.9283 0.25973 19.3127 8.50291 11.9761C16.7497 4.63941 29.397 5.35199 36.7579 13.5721L42.8209 19.6181V19.6181C45.0765 21.8737 45.1817 25.4969 43.0609 27.8796L42.4175 28.6024C39.7229 31.6296 35.0364 31.7657 32.1707 28.9L26.1791 22.9084",
    stroke: "white",
    strokeWidth: 3.63636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3773 13.5785C52.8695 7.35431 64.0001 7.37248 71.4886 14.0438C79.7318 21.3805 80.45 33.996 73.0891 42.2161L42.1289 73.0897",
    stroke: "white",
    strokeWidth: 3.63636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1797 50.5457L29.4524 40.0002",
    stroke: "white",
    strokeWidth: 3.63636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1793 44.3616L62.543 37.8162",
    stroke: "white",
    strokeWidth: 3.63636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1211 29.0896L43.5079 53.4082",
    stroke: "white",
    strokeWidth: 3.63636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2326 51.3955C51.5332 47.2408 50.04 41.3139 51.8131 35.6289C54.5052 26.9972 63.7041 22.1886 72.36 24.8883",
    stroke: "white",
    strokeWidth: 3.63636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugcareLogoIcon);
export default __webpack_public_path__ + "static/media/hugcare-logoIcon.ac46e680f0d3ad533047d233e32946ee.svg";
export { ForwardRef as ReactComponent };